module.exports = __webpack_public_path__ + "static/media/hamburger.44a4c1cb.svg";